var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.30769 13.1484C3.23077 14.0757 3.23077 11.5996 2 11.2904M10.6154 15V12.6073C10.6385 12.3125 10.5988 12.0162 10.4991 11.7379C10.3993 11.4597 10.2418 11.206 10.0369 10.9937C11.9692 10.7773 14 10.0416 14 6.66587C13.9998 5.80268 13.6693 4.97258 13.0769 4.3474C13.3575 3.5922 13.3376 2.75746 13.0215 2.01657C13.0215 2.01657 12.2954 1.80017 10.6154 2.93159C9.20493 2.54754 7.71815 2.54754 6.30769 2.93159C4.62769 1.80017 3.90154 2.01657 3.90154 2.01657C3.58546 2.75746 3.56563 3.5922 3.84615 4.3474C3.24931 4.97722 2.91848 5.81482 2.92308 6.68442C2.92308 10.0354 4.95385 10.7711 6.88615 11.0122C6.68369 11.2224 6.52755 11.4731 6.42788 11.7479C6.32822 12.0227 6.28727 12.3156 6.30769 12.6073V15",
    stroke: "#1F82FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.24dd2f80e14decaf607c0c436895a747.svg";
export { ForwardRef as ReactComponent };